import "./buttons.css";

export const BUTTON_DETAIL = {
  icon: "file-text",
  className: "button-color-blue"
};

export const BUTTON_DOWNLOAD = {
  icon: "download",
  className: "button-color-light-green"
};

export const BUTTON_DELETE = {
  icon: "delete",
  className: "button-color-red"
};

export const BUTTON_CREATE = {
  icon: "plus",
  className: "button-color-green"
};

export const BUTTON_PREVIEW = {
  icon: "eye",
  className: "button-color-light-blue"
};

export const BUTTON_DATA_EXPLORER = {
  icon: "global",
  className: "button-color-light-blue"
};

export const BUTTON_INFO = {
  icon: "info",
  className: "button-color-light-blue"
};

export const BUTTON_CUT = {
  icon: "scissor",
  className: "button-color-orange"
};

export const BUTTON_PASTE = {
  icon: "audit",
  className: "button-color-orange"
};

export const BUTTON_PASTE_AS_BROTHER = {
  icon: "solution",
  className: "button-color-orange"
};

export const BUTTON_SET_DEFAULT = {
  icon: "flag",
  className: "button-color-orange"
};

export const BUTTON_UNSET_DEFAULT = {
  icon: "flag",
  className: "button-color-orange"
};

export const BUTTON_PUBLISH = {
  icon: "database",
  className: "button-color-orange"
};

export const BUTTON_UNPUBLISH = {
  icon: "close-square",
  className: "button-color-orange"
};

export const BUTTON_INFO_PAGE = {
  icon: "export",
  className: "button-color-light-blue"
};

export const BUTTON_INFO_PAGE_LINK = {
  icon: "link",
  className: "button-color-light-blue"
};

export const BUTTON_API_LINK = {
  icon: "link",
  className: "button-color-orange"
};

export const BUTTON_CUSTOM_ANNOTATIONS = {
  icon: "info",
  className: "button-color-white"
};

export const BUTTON_DSD_UPGRADE = {
  icon: "up-square",
  className: "button-color-orange"
};

export const BUTTON_DATAFLOW_LIST = {
  icon: "unordered-list",
  className: "button-color-light-blue"
};

export const BUTTON_DSD_COMPARE = {
  icon: "block",
  className: "button-color-orange"
};

export const BUTTON_LAYOUT_ANNOTATIONS = {
  icon: "info",
  className: "button-color-orange"
};

export const BUTTON_REMOVE_EMBARGO = {
  iconText: "E",
  className: "button-color-light-blue"
};

export const BUTTON_MANAGE_OWNERS = {
  icon: "user",
  className: "button-color-orange"
};

export const BUTTON_PARENTS_AND_CHILDREN = {
  icon: "unordered-list",
  className: "button-color-light-blue"
};

export const BUTTON_CHECK_ALL_CHILDS = {
  icon: "unordered-list",
  className: "button-color-orange",
};

export const BUTTON_CONTENT_CONSTRAINTS = {
  icon: "link",
  className: "button-color-light-blue"
};

export const BUTTON_UNCATEGORIZE = {
  icon: "disconnect",
  className: "button-color-orange"
};

export const BUTTON_EMPTY_CUBE = {
  icon: "close-square",
  className: "button-color-orange"
};

export const BUTTON_CLONE = {
  icon: "copy",
  className: "button-color-green"
};

export const BUTTON_EXPORT = {
  icon: "export",
  className: "button-color-green"
};

export const BUTTON_SET_DEFAULT_ORDER = {
  className: "button-color-orange"
};

export const BUTTON_REPORTS = {
  icon: "unordered-list",
  className: "button-color-light-blue",
};

export const BUTTON_ADD_AGENCY_TO_CONFIG = {
  icon: "file-add",
  className: "button-color-orange",
};


// WEBPACK FOOTER //
// ./src/styles/buttons.js